import React from 'react'

const GraphContext = React.createContext({
  graphData: {},
  setGraphData: () => {}
})

export default GraphContext